import { Card, Drawer, Space, Typography } from "antd";
import QuizHeader from "./components/QuizHeader";
import QuizList from "./components/QuizList";
import QuizFooterActions from "./components/QuizFooterActions";
import QuizDetailsPage from "Pages/MySchedule/MyScheduledBeta/quiz/QuizDetails/QuizDetailsPage";
import { useQuizContext } from "Pages/MySchedule/MyScheduledBeta/quiz/context/QuizContext";
import QuizDrawerComponents from "Pages/MySchedule/MyScheduledBeta/quiz/QuizDrawerComponents";
import useWindowSize from "utilFunctions/CustomHooks/useWindowSize";
import { useEffect, useState } from "react";
import {
  BASE_URL,
  GET_CONFIG_FEATURE,
  QUIZ_LIST,
  QUIZ_VALIDATION_LIMIT,
} from "utilFunctions/Constants/urlConstants";
import { useLocation, useParams } from "react-router-dom";
import QuizDetailsHeader from "Pages/MySchedule/MyScheduledBeta/quiz/QuizDetails/components/QuizDetailsHeader";
import LeftArrow from "Assets/Icons/LeftArrow";
import { compareStartTime } from "utilFunctions/shared/ScheduleStatus";
import QuizCollapse from "Pages/MySchedule/MyScheduledBeta/quiz/QuizQuestions";

const QuizManagementPage = () => {
  const { id } = useParams();
  const location = useLocation();
  const {
    isDrawerOpen,
    setIsDrawerOpen,
    fetchMyScheduledData,
    isCreateMode,
    isCourseLoading,
    editableQuiz,
    setIsCourseLoading,
    setIsQuizEditable,
    quizData,
    fetchQuizLimit,
  }: any = useQuizContext();
  const { screen }: any = useWindowSize();
  const [selectedCourse, setSelectedCourse] = useState<string>();
  const params = new URLSearchParams(location.search);
  const lectureDetail = JSON.parse(params.get("data") as any);

  const { startTime } = lectureDetail || {};
  useEffect(() => {
    fetchMyScheduledData(BASE_URL + QUIZ_LIST + `/${id}`);
    const url = `${BASE_URL}${GET_CONFIG_FEATURE + QUIZ_VALIDATION_LIMIT}`;
    fetchQuizLimit(url);
  }, [id]);
  const { isFuture } = compareStartTime(startTime);
  useEffect(() => {
    setIsQuizEditable(isFuture);
  }, [isFuture]);
  return (
    <div
      className={
        !["xs", "sm", "md"].includes(screen)
          ? "batchTableContainer pt-0 pb-1 pl-5 mt-2"
          : "ml-0 mr-0"
      }
    >
      <QuizDetailsHeader scheduledata={lectureDetail || {}} />
      <Card>
        <Drawer
          open={isDrawerOpen}
          onClose={() => {
            setIsDrawerOpen(false);
          }}
          title={
            <Space>
              <LeftArrow
                className={"cursorHoverCSS"}
                onClick={() => {
                  if (editableQuiz.id) {
                    setIsDrawerOpen(false);
                  } else {
                    setIsCourseLoading(true);
                  }
                }}
              />
              <Typography.Text>
                {isCourseLoading ? "Select Topic" : "Quiz Builder"}
              </Typography.Text>
            </Space>
          }
          width={
            ["xs", "sm", "md"].includes(screen)
              ? "100%"
              : isCourseLoading
              ? "400"
              : "70%"
          }
        >
          <QuizDrawerComponents
            selectedCourse={selectedCourse}
          ></QuizDrawerComponents>
        </Drawer>
        <Space direction="vertical" size={12} style={{ width: "100%" }}>
          {!isCreateMode ? (
            <>
              <QuizHeader />
              <QuizList />
              <QuizCollapse></QuizCollapse>

              {!!quizData?.length && <QuizFooterActions />}
            </>
          ) : (
            <QuizDetailsPage
              setSelectedCourse={setSelectedCourse}
            ></QuizDetailsPage>
          )}
        </Space>
      </Card>
    </div>
  );
};

export default QuizManagementPage;
